import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataReprovacao = (): TabelaColuna => ({
  Chave: 'dataReprovacao',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.dataReprovacao)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Data Reprovação</div>
})
